export default "__VITE_ASSET__CMLLaC_h__"